/* eslint-disable no-param-reassign */
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'

export const fetchIPOAnnouncements = createAsyncThunk(
  'fetchIPOAnnouncements',
  async () => {
    const res = await axios.get(
      `${process.env.REACT_APP_IPOSERVICE_ANNOUNCEMENTS_ENDPOINT}`,
    )
    return res.data
  },
)

export const fetchIPOCases = createAsyncThunk(
  'fetchIPOCases',
  async (caseType) => {
    const jwtToken = localStorage.getItem('myrJwtToken')
    const rcpid = localStorage.getItem('rcpid')
    const url =
      window.location.hostname === 'localhost'
        ? `${process.env.REACT_APP_IPOSERVICE_MYCASES_ENDPOINT}${caseType}Cases.json`
        : `${process.env.REACT_APP_IPOSERVICE_MYCASES_ENDPOINT}/getIPO${caseType}Cases`
    const res = await axios.get(url, {
      headers: {
        JWT: jwtToken,
        XWT: rcpid,
      },
    })
    return res.data
  },
)

const initialState = {
  status: '',
  caseStatus: '',
  myCasesOpen: [],
  myCasesClosed: [],
  announcements: [],
  value: 0,
  value2: 0,
  query: '',
}

const IPOServiceCenterSlice = createSlice({
  name: 'IPOServiceCenter',
  initialState,
  reducers: {
    updateTabValue: (state, action) => {
      if (state.value !== action.payload) {
        state.value = action.payload
      }
    },
    updateTabValue2: (state, action) => {
      if (state.value2 !== action.payload) {
        state.value2 = action.payload
      }
      return state
    },
    updateQuery: (state, action) => {
      state.query = action.payload.target.value
    },
  },
  extraReducers: {
    [fetchIPOAnnouncements.pending]: (state) => ({
      ...state,
      status: 'pending',
    }),
    [fetchIPOAnnouncements.fulfilled]: (state, action) => {
      state.status = 'fulfilled'
      state.announcements = action.payload
    },
    [fetchIPOAnnouncements.rejected]: (state) => ({
      ...state,
      status: 'error',
    }),
    [fetchIPOCases.pending]: (state) => ({
      ...state,
      caseStatus: 'pending',
    }),
    [fetchIPOCases.fulfilled]: (state, action) => {
      state.caseStatus = 'fulfilled'
      const myCases = action.payload.results
      if (action.meta.arg === 'Closed') {
        state.myCasesClosed = myCases
      } else {
        state.myCasesOpen = myCases
      }
    },
    [fetchIPOCases.rejected]: (state) => ({
      ...state,
      caseStatus: 'error',
    }),
  },
})

export const { updateTabValue, updateTabValue2, updateQuery } =
  IPOServiceCenterSlice.actions

export default IPOServiceCenterSlice.reducer
